<template>
	<label class="customCheckbox">
		<input class="customCheckbox-input" type="checkbox" :checked="value" @change="$emit('input', $event.target.checked)">
		<span class="customCheckbox-control"></span>
		<span class="customCheckbox-text">
			<slot></slot>
		</span>
	</label>
</template>

<script>
	export default {
		props: {
			value: Boolean,
		},
	};
</script>

<style scoped>
	.customCheckbox {
		font-size: 14px;
	}
	.customCheckbox-text {
		margin-left: 12px;
	}
</style>
